export class SubmitSudentRelatedEventsModel {
    caseactionsk: string;
    caseactionType: number;
    notes: string;
    formJson: string;
    eventType: string;
    studentSk: string;
    relatedAction: number;
    personSk: string;
    studentOSISId: string;
    schoolDBN: string;
    dateTimeoccured: string;
    operation: number;
    constructor(data: any) {
        this.caseactionsk = null;
        this.caseactionType = data?.eventType === 'In-reach' ? 4 : 6;
        this.notes = data?.notes;
        this.formJson = JSON.stringify(data);
        this.eventType = data?.eventType === 'In-reach' ? 'Inreach' : data?.eventType;
        this.studentSk = data?.studentSk;
        this.relatedAction = data?.relatedAction?.id
        this.personSk = data?.personSk;
        this.studentOSISId = data?.studentOSISId;
        this.schoolDBN = data?.schoolDBN;
        this.dateTimeoccured = data?.dateTimeoccured
        this.operation = data?.operation
    }
    get id(): string {
        return this.caseactionsk
    }
}